module.exports = __webpack_public_path__ + "56ed2c150e84ee669406123bba3e84ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boat-shoes-brown.png
// module id = 1874
// module chunks = 0